import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlusColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 13 13"
    {...props}
  >
    <path
      fill="url(#plus-color_svg__a)"
      d="M7.04.825a.825.825 0 0 0-1.65 0V5.39H.824a.825.825 0 1 0 0 1.65h4.564v4.674a.825.825 0 0 0 1.65 0V7.04h4.675a.825.825 0 1 0 0-1.65H7.04z"
    />
    <defs>
      <linearGradient
        id="plus-color_svg__a"
        x1={10.188}
        x2={-5.486}
        y1={9.209}
        y2={8.882}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgPlusColor;
